import React, { useState } from 'react'
import './Statements.css'
import ImageInvoice from './ImageInvoice'
import moment from 'moment'
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang'
import { useSelectorCustom } from '../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { formatNumberWithCommas } from '../../../components/general/general-component/abstruct-component/FunctionRemoveCommas'

function OneExpenses({ index, expense,langLocal }) {
    const { translate } = AbstructLang()
    const [open, setOpen] = useState(false)
    const [open1, setOpen1] = useState(false)
    const { currency } = useSelectorCustom();
    return (
        <div className='one-expenses' >
            <div className='div-top-one-expenses'>
                <div className={` ${langLocal === 'ar'? "margin_left_20": "margin_right_20"} circle-num`} >{index + 1}</div>
                <img 
                src={expense?.invoice_image ? expense?.invoice_image : expense?.delivery_receipt_image} 
                className={langLocal === 'ar'? 'margin_left_15':"margin_right_15"} onClick={() => { setOpen(true) }} />
            </div>
            <div className='width-bottom-info-expenses' >
                <div className={` ${langLocal === 'ar'? "margin_right_20":"margin_left_20"} div-one-expenses`} >
                    <span className='span-one-expenses title-one-expenses'>{translate('invoice_number')}</span>
                    <span className='span-one-expenses1 sub-title-one-expenses'>{expense?.invoice_number}</span>
                </div>
                <div className={` ${langLocal === 'ar'? "margin_right_20":"margin_left_20"} div-one-expenses`} >
                    <span className='span-one-expenses title-one-expenses'>{translate('date')}</span>
                    <span className='span-one-expenses1 sub-title-one-expenses'>{moment(expense?.date).format("YYYY-MM-DD")}</span>
                </div>
                <div className={` ${langLocal === 'ar'? "margin_right_20":"margin_left_20"} div-one-expenses`} >
                    <span className='span-one-expenses title-one-expenses'>{translate('created_by')}</span>
                    <span className='span-one-expenses1 sub-title-one-expenses'>{expense?.created_by?.name}</span>
                </div>
                <div className={` ${langLocal === 'ar'? "margin_right_20":"margin_left_20"} div-one-expenses`} >
                    <span className='span-one-expenses title-one-expenses'>{translate('created_at')}</span>
                    <span className='span-one-expenses1 sub-title-one-expenses'>{moment(expense?.created_at).format("YYYY-MM-DD")}</span>
                </div>
                <div className={` ${langLocal === 'ar'? "margin_right_20":"margin_left_20"} div-one-expenses`} >
                    <span className='span-one-expenses title-one-expenses'>{translate('description')}</span>
                    <span className='span-one-expenses1 sub-title-one-expenses'>{expense?.descriptions}</span>
                </div>
                <div className={` ${langLocal === 'ar'? "margin_right_20":"margin_left_20"} div-one-expenses`} >
                    <span className='span-one-expenses title-one-expenses'>{translate('additional_notes')}</span>
                    <span className='span-one-expenses1 sub-title-one-expenses'>{expense?.notes}</span>
                </div>
                <div className={` ${langLocal === 'ar'? "margin_right_20":"margin_left_20"} div-one-expenses`} >
                    <span className='span-one-expenses title-one-expenses'>{translate('amount')}</span>
                    <span className='span-one-expenses1 sub-title-one-expenses'>{formatNumberWithCommas(expense?.amount)}  {' '} {translate(currency)}</span>
                </div>
            </div>
            {
                open && (
                    <ImageInvoice open={open} setOpen={setOpen} 
                    img={expense?.invoice_image ? expense?.invoice_image : expense?.delivery_receipt_image} />
                )
            }
        </div>
    )
}

export default OneExpenses